import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { rolesMapping } from '../../Config';

const RoleGuard = ({ title, children }) => {
    const account = useSelector((state) => state.account);
    const { user } = account;
    // useEffect(() => {
    //     console.log(user);
    // }, [user]);
    if (!user) {
        return <Redirect to="/auth/signin" />;
    }

    const allowedActions = rolesMapping[user.role]?.allowedActions || [];
    // console.log('Allowed Pages:', allowedActions);
    // console.log('title:', title);
    const hasAccess = allowedActions.includes(title);
    // console.log('Access to Page', hasAccess);
    if (!hasAccess) {
        // console.log('User Role:', user.user.role);
        return <Redirect to="/unauthorized" />;
    }

    return children;
};

export default RoleGuard;
